export default {
  errorMessage: {
    startAtUtc: 'Die Startzeit darf nicht später als die Endzeit sein.',
    endAtUtc: 'Die Endzeit darf nicht früher als die Startzeit sein.',
  },
};
